import React from "react";
import { Dimmer, Loader } from "semantic-ui-react";

export default props => (
  <div>
    <style>{`
      body > div,
      body > div > div,
      body > div > div > div.dimmer-overlay {
        height: 100%;
        background-color: #4267bb !important;
        background: #4267bb !important; /* Old browsers */
        background: -moz-linear-gradient(45deg, #4267bb 0%, #17357a 100%) !important; /* FF3.6-15 */
        background: -webkit-linear-gradient(45deg, #4267bb 0%,#17357a 100%) !important; /* Chrome10-25,Safari5.1-6 */
        background: linear-gradient(45deg, #4267bb 0%,#17357a 100%) !important; /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
        filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#4267bb', endColorstr='#17357a',GradientType=1 ) !important; /* IE6-9 fallback on horizontal gradient */
      }
    `}</style>
    <Dimmer
      active
      className="dimmer-overlay"
      style={{
        backgroundColor: "rgba(0, 0, 0, 0)"
      }}
    >
      <Loader size="massive">{props.message || "Loading..."}</Loader>
    </Dimmer>
  </div>
);



// WEBPACK FOOTER //
// ./frontend/src/views/LoadingView.js